module.exports = __webpack_public_path__ + "img/idle-dj-details3.6fdd3df4.png";